<template>
  <div class="">
    <b-row>
      <b-col cols="12" md="3">
        <b-form-group label="Date From:" label-for="date-from">
          <b-form-input
            id="date-from"
            v-model="filters.date_from"
            type="date"
            size="sm"
            @change="emitFilters"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3">
        <b-form-group label="Date To:" label-for="date-to">
          <b-form-input
            id="date-to"
            v-model="filters.date_to"
            type="date"
            size="sm"
            @change="emitFilters"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3">
        <b-form-group label="Branch:" label-for="branch-select">
          <b-form-select
            id="branch-select"
            v-model="filters.branch_id"
            :options="branchOptions"
            :disabled="loadingOptions"
            size="sm"
            @change="emitFilters"
          >
            <template #first>
              <option :value="null">Select Branch</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3">
        <b-form-group label="Project:" label-for="project-select">
          <b-form-select
            id="project-select"
            v-model="filters.project_id"
            :options="projectOptions"
            :disabled="loadingOptions"
            size="sm"
            @change="emitFilters"
          >
            <template #first>
              <option :value="null">Select Project</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3">
        <b-form-group label="Employee/Team:" label-for="employee-select">
          <b-form-select
            id="employee-select"
            v-model="filters.employee_id"
            :options="employeeOptions"
            :disabled="loadingOptions"
            size="sm"
            @change="emitFilters"
          >
            <template #first>
              <option :value="null">Select Employee/Team</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3">
        <b-form-group label="Lead Source:" label-for="lead-source-select">
          <b-form-select
            id="lead-source-select"
            v-model="filters.lead_source_id"
            :options="leadSourceOptions"
            :disabled="loadingOptions"
            size="sm"
            @change="emitFilters"
          >
            <template #first>
              <option :value="null">Select Lead Source</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3" class="d-flex align-items-end">
        <b-button variant="primary" size="sm" class="mb-1" @click="handleSearch">
          Search
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BFormSelect, BButton } from 'bootstrap-vue';
import moment from 'moment';
import axios from 'axios';

export default {
  name: 'GlobalFilterBar',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
  },
  props: {
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },
  data() {
    return {
      filters: {
        date_from: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        date_to: moment().endOf('day').format('YYYY-MM-DD'),
        branch_id: null,
        project_id: null,
        employee_id: null,
        lead_source_id: null,
      },
      branches: [],
      projects: [],
      employees: [],
      leadSources: [],
      loadingOptions: false,
    };
  },
  computed: {
    branchOptions() {
      return (this.branches || []).map((b) => ({ value: b.id, text: b.name || '' }));
    },
    projectOptions() {
      return (this.projects || []).map((p) => ({
        value: p.id,
        text: p.projectname || p.name || '',
      }));
    },
    employeeOptions() {
      return (this.employees || []).map((e) => ({
        value: e.id,
        text: e.fullname || [e.name, e.surname].filter(Boolean).join(' ') || e.name || '',
      }));
    },
    leadSourceOptions() {
      return (this.leadSources || []).map((s) => ({ value: s.id, text: s.name || '' }));
    },
  },
  mounted() {
    this.fetchFilterData();
    this.emitFilters();
  },
  methods: {
    getHeaders() {
      return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.accessToken}`,
      };
    },
    async fetchFilterData() {
      if (!this.baseApi) return;
      this.loadingOptions = true;
      try {
        await Promise.all([
          this.fetchBranches(),
          this.fetchProjects(),
          this.fetchEmployees(),
          this.fetchLeadSources(),
        ]);
      } catch (e) {
        console.error('Error loading dashboard filter options:', e);
      } finally {
        this.loadingOptions = false;
      }
    },
    async fetchBranches() {
      try {
        const res = await axios.get(`${this.baseApi}/getBranch`, { headers: this.getHeaders() });
        const raw = res.data && res.data.data;
        this.branches = Array.isArray(raw) ? raw : [];
      } catch (e) {
        console.error('Error fetching branches:', e);
        this.branches = [];
      }
    },
    async fetchProjects() {
      try {
        const res = await axios.get(`${this.baseApi}/getallproject`, { headers: this.getHeaders() });
        const raw = res.data && res.data.data;
        this.projects = Array.isArray(raw) ? raw : [];
      } catch (e) {
        console.error('Error fetching projects:', e);
        this.projects = [];
      }
    },
    async fetchEmployees() {
      try {
        const res = await axios.get(`${this.baseApi}/getEmployee`, { headers: this.getHeaders() });
        const raw = res.data && res.data.data;
        this.employees = Array.isArray(raw) ? raw : [];
      } catch (e) {
        console.error('Error fetching employees:', e);
        this.employees = [];
      }
    },
    async fetchLeadSources() {
      try {
        const res = await axios.get(`${this.baseApi}/leadsourcedata`, { headers: this.getHeaders() });
        const raw = res.data && res.data.data;
        this.leadSources = Array.isArray(raw) ? raw : [];
      } catch (e) {
        console.error('Error fetching lead sources:', e);
        this.leadSources = [];
      }
    },
    emitFilters() {
      this.$emit('filters-changed', this.filters);
    },
    handleSearch() {
      this.emitFilters();
      this.$emit('search', this.filters);
    },
  },
};
</script>

<style scoped>
.global-filter-bar {
  padding: 15px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}
</style>
